import React from 'react';

import FirebaseConnector from '../data/FirebaseConnector';

import * as auth from '../data/firebaseAuth';

class Debug extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            user: null,
            roles: null,
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        let db = new FirebaseConnector();
        console.log(await auth.getCurrentUser());
        const userData = await db.getUserData();
        console.log('userData', userData);
        this.setState({ user: userData, roles: await userData.getRoles() });
        const exerciseIds = await db.getExerciseIds();
        console.log('exerciseIds', exerciseIds);
        console.log('all exercises: ', await db.getExercises(exerciseIds));
        console.log('exercise I got: ', await db.getExercise(exerciseIds[0]));
    }

    render() {
        return (
            <>
                {this.state.user !== null &&
                    (
                        <>
                            <div>{'User: ' + this.state.user.id + '  ' + this.state.user.name + '  ' + this.state.user.email + '  ' + this.state.user.score + '    ' + JSON.stringify(this.state.roles)}</div>
                            <div>{'Is user admin? ' + (this.state.roles.admin ? 'Yes' : 'No')}</div>
                            <div>{'Is user moderator? ' + (this.state.roles.moderator ? 'Yes' : 'No')}</div>
                        </>
                    )
                }
            </>
        );
    }
}

export default Debug;